var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLazyLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4H9.5C8.70435 4 7.94129 4.31607 7.37868 4.87868C6.81607 5.44129 6.5 6.20435 6.5 7V9H8.5V7C8.5 6.73478 8.60536 6.48043 8.79289 6.29289C8.98043 6.10536 9.23478 6 9.5 6H17C17.2652 6 17.5196 6.10536 17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7V17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H9.5C9.23478 18 8.98043 17.8946 8.79289 17.7071C8.60536 17.5196 8.5 17.2652 8.5 17V15H6.5V17C6.5 17.7956 6.81607 18.5587 7.37868 19.1213C7.94129 19.6839 8.70435 20 9.5 20Z",
    fill: "#6271DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H12.585L10.585 15L12 16.415L15.7075 12.7075C15.8005 12.6146 15.8742 12.5043 15.9246 12.3829C15.9749 12.2615 16.0008 12.1314 16.0008 12C16.0008 11.8685 15.9749 11.7384 15.9246 11.617C15.8742 11.4956 15.8005 11.3853 15.7075 11.2925L12 7.58496L10.585 8.99996L12.585 11H4V13Z",
    fill: "#6271DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazyLogin);
export default __webpack_public_path__ + "static/media/lazyLogin.0df56bca3de815030eccfa6b7ed722f9.svg";
export { ForwardRef as ReactComponent };